/* Vuex mutations types for module App */
import { hToggleArrayItem } from '@/utils/helpers';

import {
  TOGGLE_PENDING_ASYNC_STORE_ACTIONS,
  SET_PROPERTIES_OF_THE_PLATFORM,
} from './mutations-types';

export default {
  [TOGGLE_PENDING_ASYNC_STORE_ACTIONS](state, payload) {
    const _state = state;
    _state.pendingAsyncStoreActions = hToggleArrayItem(_state.pendingAsyncStoreActions, payload);
  },

  [SET_PROPERTIES_OF_THE_PLATFORM](state, payload) {
    const _state = state;
    _state.lang = payload.lang;
    _state.brand = payload.brand;
    _state.support_email = payload.support_email;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/global/mutations.js